import React, {useState,useRef} from 'react'
import {localestr} from '../utils'
import icon from '../icons.svg'; 

function Keybord2({value,caption,is_liter,setValue,setModal}){
    const [val, setVal] = useState(value||'') 
    const [cnt, setCnt] = useState(0) 
    const [vol,setVol]=useState(500)
    const targetRef = useRef()

    const newVal=(v)=>{
        if(val.length>9) return
        if(val.length<4){
            if(v.charCodeAt()<65) return
            if(v.charCodeAt()>90) return
        } else {
            if(v.charCodeAt()<48) return
            if(v.charCodeAt()>57) return
        }
        let vl=val+v
        if(cnt===0) {
            vl=v
            setCnt(1)
        }
        setVal(vl)
    }

    const okClick=()=>{
        if(val.length<10&&val.length>0) return
        if(val.length>0) setValue(val+(is_liter?';'+vol:''))
        else setValue('-1') 
        setModal('')
    }

    const newKey=(e)=>{
        if(e.key==='Enter'){
            if(val.length<10&&val.length>0) return
            if(val.length>0) setValue(val+(is_liter?';'+vol:''))
            else setValue('-1')
            setModal('')
            return
        }
        if(e.key==='Backspace' && val.length){
            let vl=val.substring(0,val.length-1)
            setVal(vl)
        }
        if(e.key.length>1) return
        if(val.length>9) return
        let key=e.key
        if(val.length<4){
            if(e.key.charCodeAt()<65) return
            if(e.key.charCodeAt()>90) {
                if(e.key.charCodeAt()<97) return
                else key=key.toUpperCase()
                if(e.key.charCodeAt()>122){
                    const str1='QWERTYUIOPASDFGHJKLZXCVBNM'
                    const str2='ЙЦУКЕНГШЩЗФІВАПРОЛДЯЧСМИТЬ'
                    const ind=str2.indexOf(key)
                    if(ind!==-1) key=str1[ind]
                }
                if(key.charCodeAt()>122) return

            }
        } else {
            if(e.key.charCodeAt()<48) return
            if(e.key.charCodeAt()>57) return
        }
        let vl=val+key
        if(cnt===0) {
            vl=key
            setCnt(1)
        }
        setVal(vl)
    }

    const getSymbol=(ind)=>{
        const str='QWERTYUIOPASDFGHJKLZXCVBNMйцукенгшщзхїфівапролджєячсмитьбюЙЦУКЕНГШЩЗХЇФІВАПРОЛДЖЄЯЧСМИТЬБЮ'
        if(cnt===2) return str[ind+32]
        return str[ind]
    }

    const setFocus=(el)=>{
        if (!el) return
        setTimeout(()=>{el.focus()},100)
    }

    let liter=null
    if(is_liter) liter=<div><select value={vol} onChange={(e)=>{setVol(e.target.value)}} style={{width:'85px',height:'38px',margin:'5px 1px 0',fontSize:'larger',fontWeight:'bold',padding: '5px',border:'solid 2px #0006',borderRadius:'6px',background:'#0000'}}><option value={1000}>1л</option><option value={750}>0.75л</option><option value={700}>0.7л</option><option value={500}>0.5л</option></select></div>

    const keyStl={minWidth:'29px', display:'inline-block',verticalAlign:'bottom',flexGrow:'1',borderRadius:'6px',marginLeft:'0.5px',marginRight:'0.5px'}
    const keyStl2={height:'32px',lineHeight:'32px',display:'block'}
    const keyStl3={margin:'2px -2px 0 ',flexDirection:'row',display:'flex',justifyContent:'center'}
    if(window.innerHeight<400) {keyStl2.height='30px';keyStl2.lineHeight='30px'}
    if(window.innerWidth<400) {keyStl.margin='1px 0.5px';keyStl3.margin='2px -4px 0';keyStl3.width=(window.innerWidth-8)+'px'}

    return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{caption||localestr('Номер акцизної марки')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'><div style={{display:'flex'}}>{liter}
            <div tabIndex='0' style={{height:'24px',margin:'5px 0 0 0',fontSize:'larger',fontWeight:'bold',display:'flex',justifyContent:'left',padding: '5px',border:'solid 2px #0006',borderRadius:'6px',width:'100%'}} ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>
                {val}
            </div>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={keyStl3}>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('1')}}><div style={keyStl2}>1</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('2')}}><div style={keyStl2}>2</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('3')}}><div style={keyStl2}>3</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('4')}}><div style={keyStl2}>4</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('5')}}><div style={keyStl2}>5</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('6')}}><div style={keyStl2}>6</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('7')}}><div style={keyStl2}>7</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('8')}}><div style={keyStl2}>8</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('9')}}><div style={keyStl2}>9</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal('0')}}><div style={keyStl2}>0</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{setVal(val.slice(0, -1))}}><div style={keyStl2}><img style={{width:'20px',height:'20px',verticalAlign:'text-top'}} src={icon+'#key_b'} alt='' /></div></div>
                </div><div style={keyStl3}>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(0))}}><div style={keyStl2}>{getSymbol(0)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(1))}}><div style={keyStl2}>{getSymbol(1)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(2))}}><div style={keyStl2}>{getSymbol(2)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(3))}}><div style={keyStl2}>{getSymbol(3)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(4))}}><div style={keyStl2}>{getSymbol(4)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(5))}}><div style={keyStl2}>{getSymbol(5)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(6))}}><div style={keyStl2}>{getSymbol(6)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(7))}}><div style={keyStl2}>{getSymbol(7)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(8))}}><div style={keyStl2}>{getSymbol(8)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(9))}}><div style={keyStl2}>{getSymbol(9)}</div></div>
                </div><div style={keyStl3}>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(10))}}><div style={keyStl2}>{getSymbol(10)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(11))}}><div style={keyStl2}>{getSymbol(11)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(12))}}><div style={keyStl2}>{getSymbol(12)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(13))}}><div style={keyStl2}>{getSymbol(13)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(14))}}><div style={keyStl2}>{getSymbol(14)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(15))}}><div style={keyStl2}>{getSymbol(15)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(16))}}><div style={keyStl2}>{getSymbol(16)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(17))}}><div style={keyStl2}>{getSymbol(17)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(18))}}><div style={keyStl2}>{getSymbol(18)}</div></div>
                    <div style={{...keyStl,margin:'0 0 0 24px'}} className={'key_btn'} onClick={()=>{setVal('')}}><div style={keyStl2}><img style={{width:'16px',height:'16px'}} src={icon+'#key_x'} alt='' /></div></div>
                </div><div style={keyStl3}>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(19))}}><div style={keyStl2}>{getSymbol(19)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(20))}}><div style={keyStl2}>{getSymbol(20)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(21))}}><div style={keyStl2}>{getSymbol(21)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(22))}}><div style={keyStl2}>{getSymbol(22)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(23))}}><div style={keyStl2}>{getSymbol(23)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(24))}}><div style={keyStl2}>{getSymbol(24)}</div></div>
                    <div style={keyStl} className={'key_btn'} onClick={()=>{newVal(getSymbol(25))}}><div style={keyStl2}>{getSymbol(25)}</div></div>
                    <div style={{...keyStl,width:'68px',margin:'0 0 0 24px'}} className={'key_btn'} onClick={()=>{okClick()}}><div style={keyStl2}><img style={{width:'20px',height:'20px',verticalAlign:'text-top'}} src={icon+'#key_o'} alt='' /></div></div>
                </div>
            </div></div>
        </div></div>
    )
}

export default Keybord2